// Temporary fix for popper.js
window.process = { env: { NODE_ENV: 'production' } };

// Webpack Imports
import * as bootstrap from 'bootstrap';

const wpApi = axios.create({
  baseURL: wpApiSettings.root,
  headers: {
    'content-type': 'application/json',
    'X-WP-Nonce': wpApiSettings.nonce,
  },
});

const $ = jQuery;

//#region Utility functions.
// Function chaining.
const pipe =
  (...fns) =>
  (arg) =>
    fns.reduce((prev, fn) => fn(prev), arg);
const pipeWith = (arg, ...fns) => arg && pipe(...fns)(arg);

// String functions.
const capitalize = (str) => str[0].toUpperCase() + str.slice(1);
const insertAt = (sub, pos) => (str) =>
  `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
const insertPeriods = (str) => str.split('').join('.') + '.';
const lowercase = (str) => str.toLowerCase();
const removeWhitespace = (str) => str.replace(/\s/g, '');
const stripNonAlphabetic = (str) => str.replace(/[^a-zA-Z]+/gi, '');
const stripNumbers = (str) => str.replace(/[\d]+/gi, '');
const trim = (str) => str.trim();
const uppercase = (str) => str.toUpperCase();
//#endregion

//#region Document ready.
$(() => {
  'use-strict';

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
    el.addEventListener('submit', function (e) {
      var search = el.querySelector('input');
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: 'hover focus',
    });
  });

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      trigger: 'hover focus',
    });
  });
  //#endregion

  //#region Dropdown functions.
  $('.dropdown-submenu-toggle').on('click', function (event) {
    event.target.parentNode.querySelector('ul').classList.toggle('show');
    event.stopPropagation();
    event.preventDefault();
  });

  $('.dropdown-submenu').removeClass('show');
  $(document).on('click', function () {
    $('.dropdown-submenu').removeClass('show');
  });
  $('.dropdown-menu').on('click.bs.dropdown', function (e) {
    e.stopPropagation();
  });

  $('[data-bs-toggle="collapse"').on('click', function () {
    const icon = $(this).find('i');
    if (icon.is('.fa-angle-down, .fa-angle-up')) {
      icon.toggleClass('fa-angle-down fa-angle-up');
    } else if (icon.is('.fa-chevron-down, .fa-chevron-up')) {
      icon.toggleClass('fa-chevron-down fa-chevron-up');
    } else if (icon.is('.fa-plus, .fa-minus')) {
      icon.toggleClass('fa-plus fa-minus');
    }
  });
  //#endregion

  //#region Password visibility toggler.
  $('#password-toggle').on('click', function () {
    $('#password').attr(
      'type',
      $('#password').is(':password') ? 'text' : 'password'
    );
    if ($('#password').attr('type') === 'password') {
      $('#password-toggle-eye').removeClass('fa-eye').addClass('fa-eye-slash');
    } else {
      $('#password-toggle-eye').removeClass('fa-eye-slash').addClass('fa-eye');
    }
  });
  $('#password-confirm-toggle').on('click', function () {
    $('#password-confirm').attr(
      'type',
      $('#password-confirm').is(':password') ? 'text' : 'password'
    );
    if ($('#password-confirm').attr('type') === 'password') {
      $('#password-confirm-toggle-eye')
        .removeClass('fa-eye')
        .addClass('fa-eye-slash');
    } else {
      $('#password-confirm-toggle-eye')
        .removeClass('fa-eye-slash')
        .addClass('fa-eye');
    }
  });
  //#endregion

  //#region Form validation.

  // Fetch all the forms we want to apply custom Bootstrap validation styles to.
  var forms = document.querySelectorAll('.needs-validation');

  // Loop over them and prevent submission.
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener(
      'submit',
      function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        } else {
          $('button[type="submit"][name!="download"]', this)
            .css('pointer-events', 'none')
            .attr('tabindex', '-1')
            .addClass('disabled');
          $('button[type="submit"][clicked="true"]').prepend(
            '<div class="d-inline-flex align-middle"><span class="spinner-border spinner-border-sm me-2"></span></div>'
          );
        }
        form.classList.add('was-validated');
      },
      false
    );
  });

  $('.form-select').each(function () {
    $(this).val()
      ? $(this).addClass('has-value')
      : $(this).removeClass('has-value');
  });

  $('.form-select').on('change', function () {
    $(this).val()
      ? $(this).addClass('has-value')
      : $(this).removeClass('has-value');
  });

  $('form button[type="submit"][name!="download"]').on('click', function () {
    $('button[type="submit"]', $(this).parents('form')).removeAttr('clicked');
    $(this).attr('clicked', 'true');
  });

  // Prevent empty search parameters.
  $('#catalogSearchForm').on('submit', function () {
    $(this)
      .find(':input')
      .filter(function () {
        return !this.value;
      })
      .attr('disabled', 'disabled');
    return true;
  });
  $('#catalogSearchForm').find(':input').prop('disabled', false);
  //#endregion

  //#region Address autocompletion.
  $('#postalCode, #addressNumber').on('blur', function () {
    let postalCode = $('#postalCode').val();
    let addressNumber = $('#addressNumber').val();

    if (!postalCode || !addressNumber) return;

    postalCode = pipeWith(
      postalCode,
      removeWhitespace,
      uppercase,
      insertAt(' ', 4)
    );

    if (!/^\d{4}\s{1}[A-Z]{2}$/.test(postalCode) || !/\d+/.test(addressNumber))
      return;

    getAddress(postalCode, addressNumber).then((data) => {
      $('#postalCode').val(postalCode);
      $('#street').val(data.Street);
      $('#city').val(data.City);
      $('#country').val('NL').trigger('change');
    });
  });

  $('form').on(
    'blur',
    "input[id^='postal_code'], input[id^='address_number']",
    function (event) {
      const id = $(event.target).attr('id');
      const parts = id.split('_');
      const index = parts[parts.length - 1];

      let postalCodeInput,
        addressNumberInput,
        addressAdditionInput,
        streetInput,
        cityInput,
        countryInput;

      if (parts.length > 2) {
        postalCodeInput = $(`#postal_code_${index}`);
        addressNumberInput = $(`#address_number_${index}`);
        addressAdditionInput = $(`#address_addition_${index}`);
        streetInput = $(`#street_${index}`);
        cityInput = $(`#city_${index}`);
        countryInput = $(`#country_${index}`);
      } else {
        postalCodeInput = $('#postal_code');
        addressNumberInput = $('#address_number');
        addressAdditionInput = $('#address_addition');
        streetInput = $('#street');
        cityInput = $('#city');
        countryInput = $('#country');
      }

      let postalCode = postalCodeInput.val();
      let addressNumber = addressNumberInput.val();

      if (!postalCode || !addressNumber) return;

      postalCode = pipeWith(
        postalCode,
        removeWhitespace,
        uppercase,
        insertAt(' ', 4)
      );

      if (
        !/^\d{4}\s{1}[A-Z]{2}$/.test(postalCode) ||
        !/\d+/.test(addressNumber)
      )
        return;

      getAddress(postalCode, addressNumber).then((data) => {
        postalCodeInput.val(postalCode);
        streetInput.val(data.Street);
        cityInput.val(data.City);
        countryInput.val('NL').trigger('change');
      });
    }
  );
  //#endregion

  //#region Search input list.
  $('#catalog-search-input').on('focus', function () {
    // $('#underlay').show();
    // $('#catalog-search-result').show();
  });

  $('#catalog-search-input').on('focusout', function () {
    $('#underlay').hide();
    $('#catalog-search-result').hide();
  });
  //#endregion

  //#region Show more-fewer toggler.
  $('.toggle-more-fewer').on('click', function () {
    const label = $(this).find('span');
    const text = $(this).hasClass('collapsed') ? 'Meer' : 'Minder';
    label.text(text);
  });
  $('.toggle-show-hide').on('click', function () {
    const label = $(this).find('span');
    if ($(this).hasClass('collapsed')) {
      label.text(label.text().replace('Verberg', 'Toon'));
    } else {
      label.text(label.text().replace('Toon', 'Verberg'));
    }
  });
  //#endregion

  //#region Checkout address collapser.
  $('input:radio[name="invoice_address"]').on('change', function (e) {
    var privateCollapse = document.getElementById(
      'privateInvoiceAddressCollapse'
    );
    var companyCollapse = document.getElementById(
      'companyInvoiceAddressCollapse'
    );
    var differentCollapse = document.getElementById(
      'differentInvoiceAddressCollapse'
    );

    if (privateCollapse) {
      var bsPrivateCollapse = new bootstrap.Collapse(privateCollapse, {
        toggle: false,
      });
    }
    if (companyCollapse) {
      var bsCompanyCollapse = new bootstrap.Collapse(companyCollapse, {
        toggle: false,
      });
    }
    if (differentCollapse) {
      var bsDifferentCollapse = new bootstrap.Collapse(differentCollapse, {
        toggle: false,
      });
    }
    switch (e.currentTarget.value) {
      case 'private':
        if (bsCompanyCollapse) {
          bsCompanyCollapse.hide();
        }
        if (bsDifferentCollapse) {
          bsDifferentCollapse.hide();
        }
        $('#companyInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#differentInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#privateInvoiceAddressCollapse fieldset').removeAttr('disabled');
        bsPrivateCollapse.show();
        break;
      case 'company':
        if (bsPrivateCollapse) {
          bsPrivateCollapse.hide();
        }
        if (bsDifferentCollapse) {
          bsDifferentCollapse.hide();
        }
        $('#privateInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#differentInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#companyInvoiceAddressCollapse fieldset').removeAttr('disabled');
        bsCompanyCollapse.show();
        break;
      case 'different':
        if (bsPrivateCollapse) {
          bsPrivateCollapse.hide();
        }
        if (bsCompanyCollapse) {
          bsCompanyCollapse.hide();
        }
        $('#privateInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#companyInvoiceAddressCollapse fieldset').attr('disabled', true);
        $('#differentInvoiceAddressCollapse fieldset').removeAttr('disabled');
        bsDifferentCollapse.show();
        break;
    }
  });
  //#endregion

  //#region Checkout payment methods collapser.
  $('input:radio[name="paymentMethod"]').on('change', function (e) {
    var onlineCollapse = document.getElementById('onlineCollapse');
    var invoiceCollapse = document.getElementById('invoiceCollapse');
    var bsOnlineCollapse = new bootstrap.Collapse(onlineCollapse, {
      toggle: false,
    });
    var bsInvoiceCollapse = new bootstrap.Collapse(invoiceCollapse, {
      toggle: false,
    });
    if (e.currentTarget.value === 'online') {
      bsInvoiceCollapse.hide();
      bsOnlineCollapse.show();
    } else {
      bsOnlineCollapse.hide();
      bsInvoiceCollapse.show();
    }
  });
  // $('input:radio[name="paymentMethod"]').trigger('change');
  //#endregion

  //#region Plus-minus input buttons.
  $('[data-quantity="plus"]').on('click', function (e) {
    e.preventDefault();
    // Get the field name.
    var fieldName = $(this).data('field');
    // Get its current value.
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If is not undefined.
    if (!isNaN(currentVal)) {
      // Increment by 1.
      $('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      // Reset to 0.
      var input = $('input[name=' + fieldName + ']');
      input.val(input.attr('min') ?? 0);
    }
    $('input[name=' + fieldName + ']').trigger('change');
  });
  $('[data-quantity="minus"]').on('click', function (e) {
    e.preventDefault();
    // Get the field name.
    var fieldName = $(this).data('field');
    // Get its current value.
    var currentVal = parseInt($('input[name=' + fieldName + ']').val());
    // If it isn't undefined or its greater than 0.
    if (!isNaN(currentVal) && currentVal > 0) {
      // Decrement by 1.
      $('input[name=' + fieldName + ']').val(currentVal - 1);
    } else {
      // Reset to 0.
      $('input[name=' + fieldName + ']').val(0);
    }
    $('input[name=' + fieldName + ']').trigger('change');
  });
  $('.plus-minus-input').on('change', function (e) {
    var newVal = Number($(this).val());
    var min = Number($(this).attr('min'));
    var max = Number($(this).attr('max'));
    if (isNaN(newVal) || (min && newVal < min)) {
      $(this).val(1);
    } else if (max && newVal > max) {
      $(this).val(max);
    }
  });
  //#endregion

  $('#waiting-listModal').on('show.bs.modal', function (e) {
    var product = $(e.relatedTarget).data('product');
    var productType = $(e.relatedTarget).data('product-type');
    var productId = $(e.relatedTarget).data('product-id');
    var variantId = $(e.relatedTarget).data('variant-id');
    $('#waitingList_productName').text(product);
    $('#waitingList_productType').val(productType);
    $('#waitingList_productId').val(productId);
    $('#waitingList_variantId').val(variantId);
  });

  $('#voucherModal').on('show.bs.modal', function (e) {
    var productId = $(e.relatedTarget).data('product-id');
    var productVariantId = $(e.relatedTarget).data('product-variant-id');
    $('#product_id').val(productId);
    $('#product_variant_id').val(productVariantId);
  });

  $('#voucherButton').on('click', function (event) {
    if ($('#code').val()) {
      $('#catalogSearchForm')
        .find(':input')
        .filter(function () {
          return !(this.id == 'code');
        })
        .val(null);
    }
    $('#catalogSearchButton').trigger('click');
  });

  //#region Cart handlers
  $('.add-to-cart').on('click', function (event) {
    showButtonLoader(this);
    setTimeout(() => {
      hideButtonLoader(this);
    }, 1000);
    event.preventDefault();

    var data = {
      number: $('input[name="quantity"]').val() ?? 1,
      productType: $(this).data('type'),
      productId: $(this).data('id'),
      description: $(this).data('name'),
    };
    var voucher = $(this).data('voucher');
    if (voucher) {
      data['voucher'] = voucher;
    }

    addItemToCart(data);
  });

  $('#addExamForm').on('submit', function (event) {
    showButtonLoader($('button[type="submit"]', this));
    setTimeout(() => {
      hideButtonLoader($('button[type="submit"]', this));
    }, 1000);
    event.preventDefault();

    var data = {
      productType: $(this).data('type'),
      productId: $(this).data('id'),
      variantId: $(this).data('variant-id'),
      description: $(this).data('name'),
    };
    // addItemToCart(data);

    const form = $(this).serializeArray();
    console.log(form);
    const formData = Object.fromEntries(new FormData(this).entries());
    console.log(formData);
  });
  //#endregion

  if (document.getElementById('feedbackModal')) {
    var feedbackModal = new bootstrap.Modal(
      document.getElementById('feedbackModal'),
      {}
    );
    feedbackModal.show();
  }
});
//#endregion

//#region Address completion.
window.getAddress = function getAddress(postalCode, addressNumber) {
  return $.ajax({
    type: 'GET',
    url: 'https://datastore-v2.viperonline.nl/v2/Address',
    contentType: 'application/json',
    dataType: 'json',
    headers: {
      'Authorization-ApiKey': 'E9916AEE-15A2-42F3-B4B8-43D5B730068A',
    },
    data: {
      postalCode,
      addressNumber,
    },
  });
};
//#endregion

//#region Input validation.
window.validatePassword = function validatePassword(element) {
  let $length = $('.password-has-min-length');
  let $smallLetter = $('.password-has-small-letter');
  let $bigLetter = $('.password-has-big-letter');
  let $number = $('.password-has-number');
  let $specialCharacter = $('.password-has-special');
  let $noInvalidChars = $('.password-has-no-invalid-chars');
  let invalidChars = /[^a-zA-Z0-9~!@#$%^&*()_+{}<>?\-=\[\]\\,.\/]/;
  let specialChars = /[~!@#$%^&*()_+{}<>?\-=\[\]\\,.\/]/;

  let value = element.value;
  let errors = 0;

  // Test length
  if (value.length >= 10) {
    $length.addClass('d-none');
  } else {
    $length.removeClass('d-none');
    errors++;
  }

  // Test small letter
  if (/[a-z]/.test(value)) {
    $smallLetter.addClass('d-none');
  } else {
    $smallLetter.removeClass('d-none');
    errors++;
  }

  // Test big letter
  if (/[A-Z]/.test(value)) {
    $bigLetter.addClass('d-none');
  } else {
    $bigLetter.removeClass('d-none');
    errors++;
  }

  // Test number
  if (/[0-9]/.test(value)) {
    $number.addClass('d-none');
  } else {
    $number.removeClass('d-none');
    errors++;
  }

  // Test special character
  if (specialChars.test(value)) {
    $specialCharacter.addClass('d-none');
  } else {
    $specialCharacter.removeClass('d-none');
    errors++;
  }

  // Test invalid characters
  if (!invalidChars.test(value)) {
    $noInvalidChars.addClass('d-none');
  } else {
    $noInvalidChars.removeClass('d-none');
    errors++;
  }

  element.setCustomValidity(errors ? 'Ongeldig wachtwoord.' : '');
};

window.validateRepeatPassword = function validateRepeatPassword(
  password,
  passwordConfirm
) {
  passwordConfirm.setCustomValidity(
    passwordConfirm.value != password.value
      ? 'Wachtwoorden komen niet overeen.'
      : ''
  );
};
//#endregion

//#region Input formatting.
window.formatInitials = function formatInitials(element) {
  element.value = pipeWith(
    element.value,
    stripNonAlphabetic,
    trim,
    insertPeriods,
    uppercase
  );
};

window.formatMiddleName = function formatMiddleName(element) {
  element.value = pipeWith(element.value, stripNumbers, trim, lowercase);
};

window.formatName = function formatName(element) {
  element.value = pipeWith(element.value, stripNumbers, trim, capitalize);
};
//#endregion

//#region Product options.
window.toggleNewParticipant = function toggleNewParticipant(event, id) {
  if (event.value == 0) {
    $('#participantForm_' + id).show();
    $('#participantForm_' + id + ' :input').removeAttr('disabled');
  } else {
    $('#participantForm_' + id).hide();
    $('#participantForm_' + id + ' :input').attr('disabled', true);
  }
};

function toggleNewParticipant2(event) {
  if (event.value == 0) {
    $('#participantForm').show();
    $('#participantForm :input').removeAttr('disabled');
  } else {
    $('#participantForm').hide();
    $('#participantForm :input').attr('disabled', true);
  }
}

window.toggleOtherTrainerCompany = function toggleOtherTrainerCompany(
  event,
  id
) {
  if (event.value == 0) {
    $('#participantOtherTrainer_' + id).show();
    $('#participantOtherTrainer_' + id + ' :input').removeAttr('disabled');
  } else {
    $('#participantOtherTrainer_' + id).hide();
    $('#participantOtherTrainer_' + id + ' :input').attr('disabled', true);
    $(`input[name="participants[${id}][selected_trainer_company_name]"]`).val(
      event.options[event.selectedIndex].text
    );
  }
};

window.hideElement = function hideElement(id) {
  $(`#${id}`).hide();
  $(`#${id} :input`).attr('disabled', true);
};

window.showElement = function showElement(id) {
  $(`#${id}`).show();
  $(`#${id} :input`).removeAttr('disabled');
};

window.removeParticipant = function removeParticipant(event, id) {
  console.log('Removing participant: ', id);
};
//#endregion

//#region Miscellaneous.
window.resetInputs = function resetInputs(name = null) {
  if (name) {
    $(`input[type=checkbox][name=${name}]`).removeAttr('checked');
  } else {
    $('input[type=checkbox]').removeAttr('checked');
  }
};

window.scrollTo = function scrollTo(id) {
  $(`#${id}`)[0].scrollIntoView({ behavior: 'smooth' });
};
//#endregion

window.toggleVoucherButton = function toggleVoucherButton(event) {
  if (event.value == '') {
    $('#voucherButton').addClass('d-none');
  } else {
    $('#voucherButton').removeClass('d-none');
  }
};

//#region Cart functions.
window.addItemToCart = function addItemToCart(data) {
  wpApi
    .post('/viper-shop/v1/cart', data)
    .then((response) => {
      console.log(response.data);
      if (!response.data) {
        window.alert('Het gekozen product is momenteel niet meer beschikbaar.');
      } else {
        window.location = '/cart';
      }
    })
    .catch((error) => {
      console.error(error);
      location.reload();
    });
};

window.setCartItemCount = function setCartItemCount(element) {
  var itemId = $(element).closest('.cart-item').data('id');
  var count = Number($(element).val());
  if (isNaN(count)) return;
  if (count < 1) count = 1;
  if (itemId) {
    wpApi
      .put(`/viper-shop/v1/cart/${itemId}`, {
        quantity: count,
      })
      .then(function () {
        location.reload();
      });
  }
};

window.confirmAndSubmit = async (trigger, message) => {
  const confirm = await modalFactory.confirm(message);
  if (confirm) {
    var form = $(trigger).closest('form');
    form.trigger('submit');
  }
};

window.modalFactory = {
  confirm: async (message) => createConfirmModal(message),
};

window.createConfirmModal = (message) => {
  return new Promise((complete, failed) => {
    const template = document.getElementById('modalConfirmTemplate');
    const clone = template.content.cloneNode(true);
    document.body.appendChild(clone);
    var modal = new bootstrap.Modal(document.getElementById('modalConfirm'), {
      backdrop: 'static',
      keyboard: false,
    });
    $('#modalConfirmTitle').text(message ?? 'Actie bevestigen');
    $('#modalConfirmBody').text('Weet je het zeker?');
    $('#modalConfirmSubmit').text('Bevestigen');
    $('#modalConfirmCancel').text('Annuleren');
    $('#modalConfirmSubmit').off('click');
    $('#modalConfirmSubmit').on('click', () => {
      modal.hide();
      complete(true);
    });
    $('#modalConfirmCancel').off('click');
    $('#modalConfirmCancel').on('click', () => {
      modal.hide();
      complete(false);
    });
    $('#modalConfirm').on('hidden.bs.modal', function () {
      $(this).remove();
    });
    modal.show();
  });
};

window.removeItemFromCart = function removeItemFromCart(element) {
  var itemId = $(element).closest('.cart-item').data('id');
  if (itemId) {
    var title = 'Bevestigen';
    var body = 'Weet u zeker dat u het product wilt verwijderen?';
    var submitLabel = 'Verwijderen';
    modalConfirm(title, body, submitLabel, function () {
      wpApi
        .delete(`/viper-shop/v1/cart/${itemId}`, {})
        .then(function () {
          location.reload();
        })
        .catch((error) => console.log(error));
    });
  }
};

window.modalConfirm = function modalConfirm(
  title,
  body,
  submitLabel,
  callback
) {
  const template = document.getElementById('modalConfirmTemplate');
  const clone = template.content.cloneNode(true);
  document.body.appendChild(clone);
  var modal = new bootstrap.Modal(document.getElementById('modalConfirm'), {
    backdrop: 'static',
    keyboard: false,
  });
  $('#modalConfirmTitle').text(title);
  $('#modalConfirmBody').text(body);
  $('#modalConfirmSubmit').text(submitLabel);
  modal.show();
  $('#modalConfirmSubmit').on('click', function () {
    callback();
    modal.hide();
  });
  $('#modalConfirmCancel').on('click', function () {
    modal.hide();
  });
  $('#modalConfirm').on('hidden.bs.modal', function () {
    $(this).remove();
  });
};

window.getCart = function getCart() {
  wpApi
    .get('/viper-shop/v1/cart', {})
    .then((response) => console.log(response.data));
};
//#endregion

window.showButtonLoader = function showButtonLoader(element) {
  $(element)
    .css('pointer-events', 'none')
    .attr('tabindex', '-1')
    .addClass('disabled');
  $(element).prepend(
    '<div class="button-spinner d-inline-flex align-middle"><span class="spinner-border spinner-border-sm me-2"></span></div>'
  );
};

window.hideButtonLoader = function hideButtonLoader(element) {
  $(element)
    .css('pointer-events', 'auto')
    .attr('tabindex', '0')
    .removeClass('disabled');
  $('.button-spinner', this).remove();
};

window.toggleFormField = function toggleFormField(event, id) {
  if (event.value == 0) {
    $('#' + id).show();
    $('#' + id + ' :input').removeAttr('disabled');
  } else {
    $('#' + id).hide();
    $('#' + id + ' :input').attr('disabled', true);
  }
};

window.toggleFieldSet = function toggleFieldSet(event, id) {
  const parts = event.id.split('_');
  const index = parts[parts.length - 1];
  if (event.value == 0) {
    $(`#${id}_${index}`).show();
    $(`#${id}_${index}`).removeAttr('disabled');
  } else {
    $(`#${id}_${index}`).hide();
    $(`#${id}_${index}`).attr('disabled', true);
  }
};
